import React, { useState } from 'react';
import $ from 'jquery';
import _ from 'lodash';
import { Link, NavLink } from 'react-router-dom';
import moment from 'moment-timezone';
import TopNav from '../../commonUI/TopHeader/TopHeader';
import { getUsers } from '../../../services/adminService';
import { modal, alert } from '../../../js/modules/Dialogs';
import { sessionExpired } from '../../../config/messages';
import { adminUrl } from '../../../config/env';
import { toScreen } from '../../../js/modules/Routing';
import PropTypes from 'prop-types';
import withNavigate from '../withNavigate';

const MavSelectComponent = ({ userDetails, currentMav, selectMav, navigate }) => {

    const [isVisible, setIsVisible] = useState(false);
    const [search, setSearch] = useState('');
    const [filter, setFilter] = useState('active');
    const [sort, setSort] = useState('{"accountInfo.username":1}');
    const [mavs, setMavs] = useState({});
    const [totals, setTotals] = useState({
        total: 0,
        preactivation: 0,
        active: 0,
        resetting: 0,
        blocked: 0
    });
    const [pagination, setPagination] = useState({ page: 1, total: 1 });

    // getMavs accepts optional overrides so callers can pass new values before state updates settle
    const getMavs = (event, overrides = {}) => {

        if (event) {
            event.preventDefault();
        }

        const currentSearch  = overrides.search  !== undefined ? overrides.search  : search;
        const currentFilter  = overrides.filter  !== undefined ? overrides.filter  : filter;
        const currentSort    = overrides.sort    !== undefined ? overrides.sort    : sort;
        const currentPage    = overrides.page    !== undefined ? overrides.page    : pagination.page;

        const theUser = {
            userType: 'mav',
            search: currentSearch || undefined,
            filter: (currentFilter && currentFilter !== 'all') ? currentFilter : undefined,
            sort: currentSort || undefined,
            page: currentPage,
        };

        Object.keys(theUser).forEach(key => theUser[key] === undefined && delete theUser[key]);

        getUsers(theUser)
            .then(resJson => {
                const statusCount = _.groupBy(resJson.data || resJson.theUsers || [], 'status');

                setPagination(prev => ({
                    ...prev,
                    total: resJson.pagination?.total || resJson.totalPages || 1
                }));
                setMavs(resJson.data || resJson.theUsers || []);
                setTotals(resJson.totals || resJson);
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    modal(sessionExpired);
                    toScreen(false, navigate, '/logout');
                } else {
                    setMavs({});
                    setPagination({ page: 1, total: 1 });
                    alert(error.message || 'Error fetching MAVs');
                }
            });
    };

    const goMavSelect = (event) => {

        if (event) {
            event.preventDefault();
        }

        document.closeModalExtra = () => {
            mavSelect_close(false);
        };

        setIsVisible(true);
        getMavs();
    };

    const mavSelect_close = (event) => {

        if (event) {
            event.preventDefault();
        }

        setIsVisible(false);
    };

    const nextPage = (event) => {

        if (event) {
            event.preventDefault();
        }

        if (pagination.page < pagination.total) {
            const newPage = pagination.page + 1;
            setPagination(prev => ({ ...prev, page: newPage }));
            getMavs(false, { page: newPage });
        }
    };

    const prevPage = (event) => {

        if (event) {
            event.preventDefault();
        }

        if (pagination.page > 1) {
            const newPage = pagination.page - 1;
            setPagination(prev => ({ ...prev, page: newPage }));
            getMavs(false, { page: newPage });
        }
    };

    const searchMav = (event) => {

        if (event) {
            event.preventDefault();
        }

        setFilter('active');
        setPagination({ page: 1, total: 1 });
        getMavs(false, { filter: 'active', page: 1 });
    };

    const sortMavs = (event, theSort) => {

        if (event) {
            event.preventDefault();
        }

        var tmpSort;

        if (theSort == 'name') {
            if (sort === '{"accountInfo.username":1}') {
                tmpSort = '{"accountInfo.username":-1}';
            } else {
                tmpSort = '{"accountInfo.username":1}';
            }
        } else if (theSort == 'tel') {
            if (sort === '{"accountInfo.telephone":1}') {
                tmpSort = '{"accountInfo.telephone":-1}';
            } else {
                tmpSort = '{"accountInfo.telephone":1}';
            }
        } else if (theSort == 'location') {
            if (sort === '{"accountInfo.baseLocation.homeaddress.formattedAddress":1}') {
                tmpSort = '{"accountInfo.baseLocation.homeaddress.formattedAddress":-1}';
            } else {
                tmpSort = '{"accountInfo.baseLocation.homeaddress.formattedAddress":1}';
            }
        } else if (theSort == 'quotetotal') {
            if (sort === '{"quotetotal":1}') {
                tmpSort = '{"quotetotal":-1}';
            } else {
                tmpSort = '{"quotetotal":1}';
            }
        } else if (theSort == 'successfulquotes') {
            if (sort === '{"successfulquotes":1}') {
                tmpSort = '{"successfulquotes":-1}';
            } else {
                tmpSort = '{"successfulquotes":1}';
            }
        } else if (theSort == 'reviews') {
            if (sort === '{"totalRatings":1}') {
                tmpSort = '{"totalRatings":-1}';
            } else {
                tmpSort = '{"totalRatings":1}';
            }
        }

        setSearch('');
        setSort(tmpSort);
        setPagination({ page: 1, total: 1 });
        getMavs(false, { search: '', sort: tmpSort, page: 1 });
    };

    const handleInputChange = (event) => {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (name.split('.').length == 1) {
            if (name === 'search') setSearch(value);
            else if (name === 'filter') setFilter(value);
            else if (name === 'sort') setSort(value);
        } else if (name.split('.').length == 2) {
            if (name.split('.')[0] === 'pagination') {
                setPagination(prev => ({ ...prev, [name.split('.')[1]]: value }));
            } else if (name.split('.')[0] === 'totals') {
                setTotals(prev => ({ ...prev, [name.split('.')[1]]: value }));
            }
        }
    };

    const renderMavs = (key) => {

        const mav = mavs[key];

        let theQuoteCount = _.countBy(mav.quotes, 'status');

        return (
            <div className={currentMav != mav.short_id ? "c-list-entry" : "c-list-entry u-color-grey-dark"} key={key}>
                {/*<div className="c-list-entry__primary">
                    <b>{mav.accountInfo.username}</b> | <a href={"mailto:" + mav.accountInfo.email}>{mav.accountInfo.email}</a> | <b>{mav.short_id}</b> | {mav.status}
                </div>*/}

                <div className="c-list-entry__mavname"><b>{mav.accountInfo.username}</b></div>
                <div className="c-list-entry__tel">{mav.accountInfo.telephone}</div>
                <div className="c-list-entry__mavlocation">{mav.accountInfo.baseLocation && mav.accountInfo.baseLocation.homeaddress && mav.accountInfo.baseLocation.homeaddress.formattedAddress ? mav.accountInfo.baseLocation.homeaddress.formattedAddress.split(', United Kingdom')[0] : '(Not set)'}</div>
                <div className="c-list-entry__mavquotes"><b>{_.size(mav.quotes)}</b></div>
                <div className="c-list-entry__mavjobs"><b>{theQuoteCount.complete || 0 + theQuoteCount.paid || 0 + theQuoteCount.agreed || 0}</b></div>
                <div className="c-list-entry__reviews"><b>{mav.totalRatings}</b></div>
                <a href={adminUrl + '/mav/' + mav.short_id} target="_blank"><button type="button" className={currentMav != mav.short_id ? "c-btn c-btn--teal c-btn--small" : "c-btn c-btn--grey-dark c-btn--small"}>View</button></a>
                <button type="button" className={currentMav != mav.short_id ? "c-btn c-btn--green c-btn--small" : "c-btn c-btn--grey c-btn--small"} onClick={currentMav != mav.short_id ? (e) => selectMav(e, mav.short_id, mav.accountInfo.username) : null}>Select MAV</button>
            </div>
        );
    };

    return (
        <div>

            <div className={isVisible ? "c-modal c-modal--visible" : "c-modal"}>
                <div className="c-modal__bg js-close-modal"></div>
                <div className="c-modal__inner c-modal__inner-mav-select">

                    <div className="c-subheader-info-panel">
                        <div className="c-subheader-info-panel__primary">
                            Total active: {totals.active}
                        </div>
                        <div className="c-subheader-info-panel__search">
                            <form onSubmit={(e) => searchMav(e)}>
                                <input type="text" value={search} onChange={handleInputChange} name="search" placeholder="" className="c-subheader-info-panel__input" />
                                <button type="submit" className="c-btn-outline c-btn-outline--white c-btn-outline--small">Search</button>
                            </form>
                        </div>
                    </div>

                    <div className="l-row">

                        <div className="l-col-100">
                            <div className="c-pagination">
                                <button type="button" className="c-pagination__prev" onClick={(e) => prevPage(e)}>
                                    &lt;&lt; Prev
                                </button>
                                {pagination.page} / {pagination.total}
                                <button type="button" className="c-pagination__next" onClick={(e) => nextPage(e)}>
                                    Next &gt;&gt;
                                </button>
                            </div>
                            <div className="c-hr u-margin-bottom-0"></div>

                            <div>
                                <div className="c-list-entry c-list-entry__header">
                                    <div className="c-list-entry__mavname c-list-filter"><button className={sort == '{"accountInfo.username":-1}' ? "c-list-filter__button c-list-filter__button--icon-up" : sort == '{"accountInfo.username":1}' ? "c-list-filter__button c-list-filter__button--icon-down" : "c-list-filter__button c-list-filter__button--faded"} onClick={(e) => sortMavs(e, 'name')}>Name</button></div>
                                    <div className="c-list-entry__tel c-list-filter"><button className={sort == '{"accountInfo.telephone":-1}' ? "c-list-filter__button c-list-filter__button--icon-up" : sort == '{"accountInfo.telephone":1}' ? "c-list-filter__button c-list-filter__button--icon-down" : "c-list-filter__button c-list-filter__button--faded"} onClick={(e) => sortMavs(e, 'tel')}>Tel</button></div>
                                    <div className="c-list-entry__mavlocation c-list-filter"><button className={sort == '{"accountInfo.baseLocation.homeaddress.formattedAddress":-1}' ? "c-list-filter__button c-list-filter__button--icon-up" : sort == '{"accountInfo.baseLocation.homeaddress.formattedAddress":1}' ? "c-list-filter__button c-list-filter__button--icon-down" : "c-list-filter__button c-list-filter__button--faded"} onClick={(e) => sortMavs(e, 'location')}>Location</button></div>
                                    <div className="c-list-entry__mavquotes c-list-filter"><button className={sort == '{"quotetotal":-1}' ? "c-list-filter__button c-list-filter__button--icon-up" : sort == '{"quotetotal":1}' ? "c-list-filter__button c-list-filter__button--icon-down" : "c-list-filter__button c-list-filter__button--faded"} onClick={(e) => sortMavs(e, 'quotetotal')}>Quotes</button></div>
                                    <div className="c-list-entry__mavjobs c-list-filter"><button className={sort == '{"successfulquotes":-1}' ? "c-list-filter__button c-list-filter__button--icon-up" : sort == '{"successfulquotes":1}' ? "c-list-filter__button c-list-filter__button--icon-down" : "c-list-filter__button c-list-filter__button--faded"} onClick={(e) => sortMavs(e, 'successfulquotes')}>Jobs</button></div>
                                    <div className="c-list-entry__reviews c-list-filter"><button className={sort == '{"totalRatings":-1}' ? "c-list-filter__button c-list-filter__button--icon-up" : sort == '{"totalRatings":1}' ? "c-list-filter__button c-list-filter__button--icon-down" : "c-list-filter__button c-list-filter__button--faded"} onClick={(e) => sortMavs(e, 'reviews')}>Reviews</button></div>
                                </div>
                            </div>

                            <div>
                                {Object.keys(mavs).map(renderMavs)}
                            </div>
                            <div className="c-hr u-margin-bottom-0"></div>
                            <div className="c-pagination">
                                <button type="button" className="c-pagination__prev" onClick={(e) => prevPage(e)}>
                                    &lt;&lt; Prev
                                </button>
                                {pagination.page} / {pagination.total}
                                <button type="button" className="c-pagination__next" onClick={(e) => nextPage(e)}>
                                    Next &gt;&gt;
                                </button>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

        </div>
    );
};

MavSelectComponent.propTypes = {
    userDetails: PropTypes.object.isRequired,
    currentMav: PropTypes.string.isRequired,
    selectMav: PropTypes.func.isRequired
};

export default withNavigate(MavSelectComponent);
